import React from 'react'
import { useLocation } from 'react-router-dom'
import './openSec.css'

export default function OpenSec() {

  
  const location = useLocation();
  return (
    <div>{ location.state }</div>
  )
}

